module.exports = __webpack_public_path__ + "media/images/cleaning/card-mobile-96006d4b53e4c456ceccdb050c4bec95.jpg";